// This module is use to store the redirect url
// Only use with the mixins/redirect.js to simuate a redirect action.
// A hack for the Power Point Add-in

// The reason is the Power Point Add-in doesn't support history.pushState() and history.replaceState()
// Ideally, we just need to change the vue-router mode from 'history' to hash 'mode'
// But our presenter app has been using history mode for a long time, and we add so many conditions to handle those redirect edge cases.
// (Which I assume It's not the proper way to do it)
// So I just use this hack to simulate the redirect action.

const _state = {
  redirectStore: null,
}

const actions = {
  setRedirectStoreAction({ commit }, payload) {
    commit('setRedirectStore', payload)
  },
}

const _getters = {
  redirectStore: (state) => state.redirectStore,
  urlQueryParams: (state) => state.redirectStore?.query,
}

const mutations = {
  setRedirectStore(state, payload) {
    state.redirectStore = payload
  },
}

export default {
  namespaced: true,
  state: _state,
  actions,
  mutations,
  getters: _getters,
}
